module.exports = __webpack_public_path__ + "static/media/(V)_MG_5221_-_Pro-Natura_-_Moda_Feminina_-_Moda_Feminina_Infantil.959a01ac.jpg";